import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface PreviewCard {
  number: string;
  photographer: string;
  era: string;
  location: string;
}

const PREVIEW_CARDS: readonly PreviewCard[] = [
  { number: '001', photographer: 'Jon Asher',     era: '1968', location: 'NHRA U.S. Nationals · Indianapolis' },
  { number: '047', photographer: 'Steve Reyes',   era: '1971', location: 'NHRA Winternationals · Pomona' },
  { number: '112', photographer: 'Bob McClurg',   era: '1970', location: 'Lions Drag Strip · Wilmington' },
  { number: '218', photographer: 'Jere Alhadeff', era: '1973', location: 'OCIR · Orange County Raceway' },
  { number: '294', photographer: 'Tom West',      era: '1969', location: 'NHRA Springnationals · Dallas' },
  { number: '361', photographer: 'Les Welch',     era: '1972', location: 'Englishtown · Old Bridge Township' },
];

export default function Heritage() {
  const { user } = useAuth();

  return (
    <div className="app">
      <div className="main">
        <section className="heritage-hero">
          <div className="heritage-eyebrow">Coming Q3 2026 · From Slightly Wicked Customs</div>
          <h1 className="heritage-display">The Heritage Archive</h1>
          <p className="heritage-tagline">
            The lost negatives of American drag racing.
          </p>
          <p className="heritage-lead">
            Five thousand high-resolution scans. Seventeen pro photographers. Over three million
            negatives in the master archive. Images that have never been seen publicly — pulled
            from the personal collections of the working press corps who shot Hot Rod, National
            Dragster, Drag News, and Car Craft from the 1960s through the 1990s.
          </p>
          <div className="heritage-stats">
            <div>
              <div className="heritage-stat-value">17</div>
              <div className="heritage-stat-label">Pro Photographers</div>
            </div>
            <div>
              <div className="heritage-stat-value">5,000+</div>
              <div className="heritage-stat-label">Scanned at Launch</div>
            </div>
            <div>
              <div className="heritage-stat-value">3M+</div>
              <div className="heritage-stat-label">Master Negatives</div>
            </div>
            <div>
              <div className="heritage-stat-value">0</div>
              <div className="heritage-stat-label">Previously Published</div>
            </div>
          </div>
        </section>

        <section style={{ marginTop: 48 }}>
          <div className="eyebrow">Preview · Subscriber Early Access</div>
          <h2 className="h-section" style={{ fontSize: 24, marginBottom: 8 }}>From the coming archive.</h2>
          <p style={{ color: 'var(--text-dim)', fontSize: 14, lineHeight: 1.6, maxWidth: 640, marginBottom: 28 }}>
            A sampling of what's coming. Final prints, digital downloads, and commercial licensing
            launch Q3. SWC subscribers get first-look access, founding-member pricing, and
            invitations to the launch event.
          </p>

          <div className="heritage-grid">
            {PREVIEW_CARDS.map((card) => (
              <article key={card.number} className="heritage-card">
                <div className="heritage-card-photo">
                  <div className="heritage-card-number">№ {card.number}</div>
                  <div className="heritage-card-mark">COMING</div>
                </div>
                <div className="heritage-card-info">
                  <div className="heritage-card-credit">PHOTO — {card.photographer.toUpperCase()}</div>
                  <div className="heritage-card-meta">{card.era} · {card.location}</div>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="heritage-cta">
          <div className="eyebrow">Subscribers · Founding Access</div>
          <h2 className="h-title" style={{ fontSize: 28, marginBottom: 12 }}>
            You're on the early-access list.
          </h2>
          <p style={{ color: 'var(--text-dim)', fontSize: 14, lineHeight: 1.6, maxWidth: 560, margin: '0 auto 22px' }}>
            Because you're signed in as <strong style={{ color: 'var(--cream)' }}>{user?.email}</strong>,
            we'll email you the moment the first photographer's collection goes live — and you'll
            get founding-member pricing on prints and downloads.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/inventory" className="btn ghost">← Back to Parts</Link>
            <Link to="/account" className="btn dark">Account Settings</Link>
          </div>
        </section>
      </div>
    </div>
  );
}
